import './Separator.css';
import React from 'react';

function Separator() {
  return <div className="separator" />;
}

export default Separator;
